import type { SellingBanner } from '@/types/sellingBanner'

// 2024/11/20 現在ではバナーの管理は開発手作業で行う かつ 更新頻度も少ないため
// 不要な fetch を減らせるメリットを優先しハードコードする
export const SellingBanners: SellingBanner[] = [
  {
    sellingBannerId: '35',
    bannerTitle: 'ポケカオリパ販売!',
    bannerImageUrl: 'https://assets.ka-nabell.com/selling-web/pokemon/banners/202511131716_1.jpg',
    priorityNumber: 1,
    linkUrl: 'https://www.ka-nabell.com/?act=sell_detail&id=100379343&genre=7&type=4&category=&supply=1&lang=',
    targetAttribute: '_blank',
    startDate: new Date('2025-11-14T18:00:00'),
  },
  {
    sellingBannerId: '33',
    bannerTitle: '人気未開封BOXプレゼント!',
    bannerImageUrl: 'https://assets.ka-nabell.com/selling-web/pokemon/banners/202511101227_1.jpg',
    priorityNumber: 1,
    startDate: new Date('2025-11-10T18:00:00'),
    endDate: new Date('2025-11-21T23:59:59'),
  },
  {
    sellingBannerId: '34',
    bannerTitle: 'シングルカード特価セール',
    bannerImageUrl: 'https://assets.ka-nabell.com/selling-web/pokemon/banners/202511101227_2.jpg',
    priorityNumber: 1,
    linkUrl: 'https://sell.ka-nabell.com/pokemon/search?keyword=%E3%80%90SALE%E3%80%91',
    targetAttribute: '_self',
    startDate: new Date('2025-11-10T18:00:00'),
    endDate: new Date('2025-11-31T23:59:59'),
  },
  {
    sellingBannerId: '32',
    bannerTitle: 'インフェルノX販売中',
    bannerImageUrl: 'https://assets.ka-nabell.com/selling-web/pokemon/banners/202509221105_2.jpg',
    priorityNumber: 1,
    linkUrl: 'https://sell.ka-nabell.com/pokemon/search?packId=436',
    targetAttribute: '_self',
    startDate: new Date('2025-09-26T07:00:00'),
  },
  {
    sellingBannerId: '27',
    bannerTitle: 'メガゲンガーex & メガディアンシーex 販売中',
    bannerImageUrl: 'https://assets.ka-nabell.com/selling-web/pokemon/banners/202509011010_2.jpg',
    priorityNumber: 1,
    linkUrl: 'https://sell.ka-nabell.com/pokemon/search',
    targetAttribute: '_self',
    startDate: new Date('2025-09-05T07:00:00'),
  },
  {
    sellingBannerId: '21',
    bannerTitle: 'メガブレイブ&メガシンフォニア販売中',
    bannerImageUrl: 'https://assets.ka-nabell.com/selling-web/pokemon/banners/202507290941_2.jpg',
    priorityNumber: 1,
    linkUrl: 'https://sell.ka-nabell.com/pokemon/search',
    targetAttribute: '_self',
    startDate: new Date('2025-08-01T07:00:00'),
  },
  {
    sellingBannerId: '18',
    bannerTitle: '鑑定済みカード販売中',
    bannerImageUrl: 'https://assets.ka-nabell.com/selling-web/pokemon/banners/202506171620_1.jpg',
    priorityNumber: 1,
    linkUrl: 'https://sell.ka-nabell.com/pokemon/search?keyword=%E2%80%BB%E7%89%B9%E7%AD%86%E4%BA%8B%E9%A0%85%E8%A6%81%E7%A2%BA%E8%AA%8D',
    targetAttribute: '_self',
    startDate: new Date('2025-06-17T18:00:00'),
  },
  {
    sellingBannerId: '6',
    bannerTitle: 'ポイント利用',
    bannerImageUrl: 'https://assets.ka-nabell.com/selling-web/pokemon/banners/202412040925_1.jpg',
    priorityNumber: 1,
    linkUrl: 'https://gachi-matome.com/p-pcg-news-20241202/',
    targetAttribute: '_blank',
    startDate: new Date('2024-12-04T00:00:00'),
  },
  {
    sellingBannerId: '7',
    bannerTitle: 'PayPay告知',
    bannerImageUrl: 'https://assets.ka-nabell.com/selling-web/pokemon/banners/202412040925_2.gif',
    priorityNumber: 1,
    startDate: new Date('2024-12-04T00:00:00'),
  },
  {
    sellingBannerId: '5',
    bannerTitle: '買取サイトはこちらへ',
    bannerImageUrl: 'https://assets.ka-nabell.com/selling-web/pokemon/banners/202411211516_1.jpg',
    priorityNumber: 1,
    linkUrl: 'https://www.ka-nabell.com/?act=buy_top&genre=10&utm_source=NewEC&utm_medium=banner&utm_campaign=NewEcConnect',
    targetAttribute: '_self',
    startDate: new Date('2024-11-21T15:00:00'),
  },
  {
    sellingBannerId: '1',
    bannerTitle: 'サイトリニューアルに関する重要なお知らせ',
    bannerImageUrl: 'https://assets.ka-nabell.com/selling-web/pokemon/banners/202411141332_1.jpg',
    priorityNumber: 2,
    linkUrl: 'https://gachi-matome.com/p-pcg-news-20241120',
    targetAttribute: '_blank',
    startDate: new Date('2024-11-14T00:00:00'),
  },
]
